import React from 'react';

const resume = "https://drive.google.com/file/d/1zT-tinEwM56kHyhARjDPeee_WIOfMOBL/preview";

export const Resume = () => (
  <section className="banner" style={{"display": "flex", "flexDirection": "column", "justifyContent": "center"}}>
    <h1 className='heading'>RESUME</h1>
    <iframe className='resume' src={resume} allow="autoplay" title="Resume" />
  </section>
);
